import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useI18n } from '../i18n/I18nProvider';
import { useAuth } from './AuthContext';

/** Vòng chờ trong lúc kiểm tra phiên đã lưu, để không lóe lên trang đăng nhập rồi lại nhảy đi. */
function Checking() {
  const { t } = useI18n();

  return (
    <div className="text-center text-body-secondary py-5">
      <div className="spinner-border" role="status" aria-hidden="true" />
      <div className="mt-2">{t('common.checkingSession')}</div>
    </div>
  );
}

export function RequireAuth({ children }: { children: React.ReactElement }) {
  const { user, initialising } = useAuth();
  const location = useLocation();

  if (initialising) return <Checking />;

  // Nhớ nơi người dùng định đến, để đăng nhập xong quay lại đúng chỗ đó.
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;

  return children;
}

export function RequireAnonymous({ children }: { children: React.ReactElement }) {
  const { user, initialising } = useAuth();

  if (initialising) return <Checking />;
  if (user) return <Navigate to="/" replace />;

  return children;
}
